import React from 'react';

const Family = () => {
    return (<h1>Hi, this is family section!</h1>);
};

export default Family;
